import {
    ChangeDetectionStrategy,
    Component,
    HostListener,
    Input,
    OnInit,
    inject,
} from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { HeaderFooterElements } from '@shared-interfaces/shared-header-footer';
import { HeaderMenuComponent } from './ui/header-menu/header-menu.component';
import { Router } from '@angular/router';
import { HeaderService } from './data-access/header.service';
import { CommonModule } from '@angular/common';
import { AuthService } from 'projects/shared/src/lib/auth/auth/data-access/auth.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderService } from '@shared-utils/loader/loader.service';
import { MatDividerModule } from '@angular/material/divider';
import { RoleService } from './data-access/role.service';
import { Observable, combineLatest, map } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'shared-header',
    standalone: true,
    imports: [
        MatToolbarModule,
        HeaderMenuComponent,
        CommonModule,
        MatProgressBarModule,
        MatDividerModule
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
    private router = inject(Router);
    private headerService = inject(HeaderService);
    private authService = inject(AuthService);
    private loaderService = inject(LoaderService);
    private roleService = inject(RoleService);

    headerMenuElements$: Observable<HeaderFooterElements | undefined> = combineLatest([
        toObservable(this.headerService.headerConfig),
        this.roleService.isAdmin()
    ]).pipe(
        map(([config, isAdmin]) => {
            if (!isAdmin && config?.nameUrls) {
                const { Administration, ...rest } = config.nameUrls;
                return { ...config, nameUrls: rest };
            }
            return config;
        })
    );
    
    user$ = this.authService.user;
    apiLoading$ = this.loaderService.loader$;
    innerWidth: number = 1366;

    @Input() headerMenuElements: HeaderFooterElements | undefined = undefined;

    ngOnInit(): void {
        this.headerService.getMenuItems();
        this.innerWidth = window.innerWidth;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.innerWidth = window.innerWidth;
    }

    navigateTo(path: string): void {
        if (path === 'logout') {
            this.authService.logout();
        } else if (path === 'selector') {
            this.router.navigate([path]);
        } else {
            this.router.navigate([path], {
                queryParamsHandling: 'merge',
            });
        }
    }
}
